/**
 * Prefix of every identity's open drafts. It lives here, not with the query
 * options, because the chat's send refreshes it after every message from
 * outside the feature, and only an entry point may be imported from there.
 * Invalidating by the prefix is enough: only the active identity's entry is
 * mounted.
 */
export const OPEN_REPLY_DRAFTS_QUERY_KEY = ['replyDraftsV2'] as const;

/** The open drafts of the identity the app is acting as. */
export const openReplyDraftsQueryKey = (userId: string | undefined) =>
  [...OPEN_REPLY_DRAFTS_QUERY_KEY, userId] as const;
